export function pickLlmText(resp: unknown): string {
  if (!resp) return '';
  if (typeof resp === 'string') return resp;
  const r = resp as Record<string, unknown>;
  const result = r.result as Record<string, unknown> | undefined;
  const internal = result?.internal_data as Record<string, unknown> | undefined;
  if (internal?.response) return String(internal.response);
  const topInternal = r.internal_data as Record<string, unknown> | undefined;
  if (topInternal?.response) return String(topInternal.response);
  if (result?.response) return String(result.response);
  if (result?.output) return String(result.output);
  if (result?.text) return String(result.text);
  return JSON.stringify(resp, null, 2);
}

const EXPLAIN_PROMPT = `You explain DevCockpit agent actions to platform operators in plain language.

Given JSON for a single action (fix, deploy, sync, promotion, etc.), write a concise explanation covering:
1. What triggered the action and which app was involved
2. The key steps that happened (2-4 sentences, no jargon)
3. The outcome and whether anything still needs attention

Use short paragraphs or bullet points. Do not echo raw JSON. Be direct and helpful.`;

export { EXPLAIN_PROMPT };
